import React from "react";
import { Link } from "react-router-dom";
import { CardTitle } from "../typography/typography";
import { Button } from "../elements/buttons";
import { BodyCopy } from "../typography/typography";

/*
    Images
*/
export class Image extends React.Component {
  /*constructor( props ){

    }*/

  render() {
    let classes = "";
    if (typeof this.props.classes !== "undefined") {
      classes = this.props.classes;
    }
    let imgClasses = "";
    if (typeof this.props.imgClasses !== "undefined") {
      imgClasses = this.props.imgClasses;
    }

    //default non-responsive image
    let image = (
      <img className={imgClasses} src={this.props.src} alt={this.props.alt} />
    );

    //if responsive
    if (
      typeof this.props.sizes !== "undefined" &&
      typeof this.props.srcSet !== "undefined"
    ) {
      image = (
        <ResponsiveImage
          src={this.props.src}
          alt={this.props.alt}
          classes={imgClasses}
          sizes={this.props.sizes}
          srcSet={this.props.srcSet}
        />
      );
    }

    return <div className={`image-wrap ${classes}`}>{image}</div>;
  }
}

class ResponsiveImage extends React.Component {
  render() {
    return (
      <img
        src={this.props.src}
        alt={this.props.alt}
        className={this.props.classes}
        sizes={this.props.sizes}
        srcSet={this.props.srcSet}
      />
    );
  }
}

/*
    List Group
*/
export class ListGroup extends React.Component {
  /*constructor( props ){

    }*/
  render() {
    return (
      <ul className={`list-wrap ${this.props.classes}`}>
        {this.props.children}
      </ul>
    );
  }
}

/*
    List Item
*/
export class ListItem extends React.Component {
  render() {
    return (
      <li className={`list-item ${this.props.classes}`}>
        {this.props.children}
      </li>
    );
  }
}

/*
    Page Section
*/
export class Section extends React.Component {
  render() {
    return (
      <section id={this.props.id} className={`section ${this.props.classes}`}>
        {this.props.children}
      </section>
    );
  }
}

/*
    Card
*/
export class Card extends React.Component {
  render() {
    let cardContent = null;

    //recipe card layout
    if (this.props.type === "recipe") {
      cardContent = (
        <div className="card-inner">
          <CardTitle color={this.props.color} classes="color-gray-dark">
            {this.props.title}
          </CardTitle>
          <Image src={this.props.image} alt={this.props.title} />
          {typeof this.props.desc !== "undefined" && (
            <BodyCopy classes="color-gray margin-top-medium margin-bottom-small">
              {this.props.desc}
            </BodyCopy>
          )}
          {this.props.children}
        </div>
      );
    }

    //product card layout
    if (this.props.type === "product") {
      cardContent = (
        <div className="card-inner">
          <Image
            classes="margin-bottom-small"
            src={this.props.image}
            alt={this.props.title}
          />
          <CardTitle color={this.props.color} classes="color-gray-dark">
            {this.props.title}
          </CardTitle>
          {typeof this.props.desc !== "undefined" && (
            <BodyCopy classes="color-gray margin-top-medium margin-bottom-small">
              {this.props.desc}
            </BodyCopy>
          )}
          {this.props.children}
        </div>
      );
    }

    let usingFlip = "";
    if (this.props.flip === true) {
      usingFlip = "card-usingFlip";
    }

    let link = null;
    if (this.props.link !== "undefined") {
      link = this.props.link;
    }
    if (this.props.linkType === "dynamic") {
      link = `/${this.props.type}s/${this.props.link}`;
    }

    let classes = "";
    if (typeof this.props.classes !== "undefined") {
      classes = this.props.classes;
    }

    return (
      <div
        className={`card padding-y-medium padding-x-large ${classes} ${usingFlip}`}
        data-type={this.props.type}
      >
        <div className="card-flipWrap">
          {typeof this.props.link !== "undefined" && (
            <Link
              to={link}
              data-section={
                typeof this.props.category !== "undefined"
                  ? this.props.category
                  : "Uncategorized"
              }
              data-subsection={this.props.title}
              data-pagetype={
                typeof this.props.pageType !== "undefined"
                  ? this.props.pageType
                  : "Detail"
              }
            >
              {cardContent}
              <Button
                classes={this.props.button.size}
                color={this.props.color}
                text={this.props.button.text}
              />
            </Link>
          )}
          {typeof this.props.link === "undefined" && (
            <Button
              classes={this.props.button.size}
              color={this.props.color}
              text={this.props.button.text}
            />
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/bodyComponents.js